import { render, staticRenderFns } from "./TabPaneContent.vue?vue&type=template&id=8aeca6c4&scoped=true"
import script from "./TabPaneContent.vue?vue&type=script&lang=js"
export * from "./TabPaneContent.vue?vue&type=script&lang=js"
import style0 from "./TabPaneContent.vue?vue&type=style&index=0&id=8aeca6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeca6c4",
  null
  
)

export default component.exports